var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.limit),function(i){return _c('div',{key:i,staticClass:"segment",style:({ background: _vm.segmentColor(i) })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }